export default class MainService {

	constructor() {
		this.apiUrl = '/guide-api';
	}
}



// WEBPACK FOOTER //
// ./src/service/MainService.js